<template>
  <section class="page-container">
    <div>
      <h1>Referrer Reward</h1>
      <div
        class="btn-top-container">
        <v-button
          v-if="showExportBtn"
          type="plain"
          size="mini"
          :disabled="exportDisable"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
    </div>
    <el-tabs
      v-model="active"
      @tab-click="changeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab"
        :name="tab"
      ></el-tab-pane>
    </el-tabs>
    <talk-list
      v-if="active == 'Referrer Talks'"
      ref="ReferrerTalks"
      @changeDate='setExportStatus'></talk-list>
    <partner-links
      v-if="active == 'Partner Links'"
      ref="PartnerLinks"
      @changeDate='setExportStatus'></partner-links>
    <refer-bonus-list  v-if="active == 'Referrer Bonus'">
    </refer-bonus-list>
    <incentive-bonus-list  v-if="active == 'Incentive Bonus'">
    </incentive-bonus-list>
  </section>
</template>

<script>

import TalkList from '../micropolicy/components/referrer-talks-list.vue'
import PartnerLinks from '../micropolicy/components/partner-links-list.vue'
import ReferBonusList from '../micropolicy/components/refer-bonus-list'
import IncentiveBonusList from './component/incentive-bonus-list'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'Policy',
  components:{
    TalkList,
    PartnerLinks,
    ReferBonusList,
    IncentiveBonusList,
  },
  data() {
    return{
      exportDisable: true,
      active: 'Referrer Talks',
      tabList:['Referrer Talks','Partner Links','Referrer Bonus','Incentive Bonus']
    }
  },
  computed:{
    ...mapState('micropolicy',['activeReferrerTab']),
    showExportBtn(){
      return !['Referrer Talks','Partner Links','Referrer Bonus','Incentive Bonus'].includes(this.active)
    }
  },
  watch:{
    activeReferrerTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.active =val
        }
      }
    }
  },
  methods: {
    ...mapActions('micropolicy',['setActiveReferrerTab']),
    handlerDown() {
      let name = this.active.replace(/\s*/g,'')
      this.$refs[name].handlerDown()
    },
    setExportStatus(val){
      this.exportDisable = val.length == 0
    },

    changeTab(){
      this.setActiveReferrerTab(this.active)
      this.exportDisable = true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
}
</style>
